import Vue from "vue";
import moment from "moment";
import ApiService from "../../../../../services/api";
import gridbase from "../../../../../components/gridComponentBase.js";
import { mapGetters } from "vuex";
import helpers from "../../../../../shared/fleetbox-helpers";
import { bus } from "../../../../../main";

export default {
	extends: gridbase,
	props: {
		filters: Array
	},
	data: function() {
		return {
			columns: [
				{
					field: "number_plate",
					configId: "number_plate",
					title: "targa",
					width: "100",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "vehicle_code",
					configId: "vehicle_code",
					title: "codice",
					width: "130",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "vehicle_name",
					title: "veicolo",
					configId: "vehicle_name",
					width: "290",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "driver_name",
					title: "conducente",
					configId: "driver_name",
					width: "200",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "division_name",
					title: "divisione",
					configId: "division_name",
					width: "200",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					permit: "hasDivisions",
					sortable: false
				},
				{
					field: "event_date",
					configId: "event_date",
					title: "data",
					width: "200",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "datetime",
					filterable: false,
					sortable: false
				},
				{
					field: "description",
					configId: "description",
					title: "evento",
					width: "480",
					headerCell: "myHeaderTemplate",
					format: "",
					sortable: false,
					filterable: false
				},
				{
					field: "main_category",
					configId: "category",
					title: "evento",
					width: "200",
					headerCell: "myHeaderTemplate",
					format: "",
					sortable: false,
					filterable: false
				},
				{
					field: "latitude",
					configId: "latitude",
					title: "posizione",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "",
					cell: "positionCoordinates",
					filterable: false,
					sortable: false
				},
				{
					field: "longitude",
					configId: "longitude",
					title: "posizione",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "",
					cell: "positionCoordinates",
					filterable: false,
					sortable: false
				},
				{
					field: "value",
					configId: "value",
					title: "Valore",
					headerCell: "myHeaderTemplate",
					format: "",
					width: "200",
					filterable: false,
					sortable: false
				},
				{
					field: "um",
					configId: "unit",
					title: "UM",
					headerCell: "myHeaderTemplate",
					format: "",
					width: "80",
					filterable: false,
					sortable: false
				},
				{
					field: "other_data",
					configId: "other_data",
					title: "Altri dati",
					width: "300",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				}
			],

			config: [],
			items: [],

			vehicleIdFilterField: "number_plate",
			vehicleIdFilterFieldFormatted: "vehicles",
			hasDivisions: false
		};
	},

	created() {
		this.hasSelectedMode = true;
		this.query.pageSize = 25;
		this.take = 25;

		if (this.settings && this.settings.defaultPageSize && this.settings.defaultPageSize > 0) {
			this.query.pageSize = parseInt(this.settings.defaultPageSize);
			this.take = parseInt(this.settings.defaultPageSize);
		}
		if (this.settings && this.settings.hasDivisions) this.hasDivisions = true;

		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;
		this.vehicleIdFilterFieldFormatted = "vehicles";
		if (this.vehicleIdFilterField == "code") {
			this.vehicleIdFilterFieldFormatted = "vehicleCodes";
		}
	},
	mounted() {
		this.getConfig();
	},
	watch: {
		// filters: {
		// 	handler: function() {
		// 		this.skip = 0;
		// 		this.query.page = 0;
		// 		this.getData();
		// 	},
		// 	deep: true
		// }
	},
	methods: {
		applyReportFilter() {
			this.skip = 0;
			this.query.page = 0;
			this.getData();
		},
		formattedCoordinates(current_position, typeCoord) {
			if (current_position && current_position.lat && current_position.lon) {
				var tc = typeCoord.substring(0, 3);
				return helpers.formatCoordinate(current_position[tc], tc);
			}
			return null;
		},
		getConfig: function() {
			var self = this;
			ApiService.getViewConfig("fleerun_report_last_diagnosis")
				.then(res => {
					self.config = res;
					self.setConfigColumns();
				})
				.finally(res => {
					self.getData();
				});
		},
		setConfigColumns() {
			var self = this;
			if (self.config && self.config.length > 0) {
				var orderedConfigColumn = self._.orderBy(self.config, "order", "asc");

				orderedConfigColumn.forEach(column => {
					var defColumn = self.columns.find(function(f) {
						return f.configId === column.field;
					});

					if (defColumn && column.enabled && (!defColumn.permit || self[defColumn.permit])) {
						defColumn.title = column.label;

						self.columnsToShow.push(defColumn);
					}
				});

				if (self.columnsToShow.length > 0) {
					var columnsByPassConfig = self._.filter(self.columns, function(item) {
						return item.configByPass;
					});

					for (var i = 0; i < columnsByPassConfig.length; i++) {
						self.columnsToShow.push(columnsByPassConfig[i]);
					}
				}

				self.dataReady = true;
			}
		},
		sortChangeHandler: function(e) {
			this.sort = e.sort;
			this.getData();
		},
		pageChangeHandler: function(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;

			if (this.skip === 0) {
				this.query.page = 0;
			}
			this.query.page = this.skip / this.take;

			this.getData();
		},
		downloadXlsx: function(type) {
			var self = this;
			var data = this.getRequestData();
			if (type == "csv") data["format"] = "csv";
			ApiService.exportChartXlsx("last-diagnosis", data).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Diagnosi.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		getData: function() {
			var self = this;

			this.$emit("on-loading", true);

			var data = this.getRequestData();

			ApiService.getLastDiagnosticReportData(data).then(res => {
				self.items = res.items.map(a => {
					return {
						id: a.id,
						trip_id: a.trip_id,
						event_date: a.event_date,
						box_serial_number: a.box_serial_number,
						number_plate: a.number_plate,
						vehicle_id: a.vehicle_id,
						vehicle_code: a.vehicle_code,
						vehicle_name: a.vehicle_name,
						driver_id: a.driver_id,
						driver_name: a.driver_name,
						division_name: a.division_name,
						type: a.type,
						subtype: a.subtype,
						icon: a.icon,
						car_gear_position_type: a.car_gear_position_type,
						type_name: a.type_name,
						description: a.description,
						timestamp: a.timestamp,
						mas: a.mas,
						speed: a.speed,
						position: a.position,
						position_name: a.position_display_name,
						drive_direction: a.drive_direction,
						data_category_description: a.data_category_description,
						data: a.data,
						main_category: a.main_category,
						other_data: a.other_data,

						//custom field
						diagnostic_description: a.data && a.data.category_description ? a.data.category_description : "",
						value: a.data && a.data.value ? a.data.value : "",
						um: a.data && a.data.unit ? a.data.unit : "",
						event_date_date: self.$options.filters.dateToString(a.event_date),
						event_date_time: self.$options.filters.timeToString(a.event_date)
					};
				});

				self.total = res.totalCount;

				self.$emit("on-loading", false);
			});
		},
		getRequestData() {
			var self = this;
			var data = {};

			if (this.sort && this.sort.length > 0) {
				var sortParam = "";
				for (var i = 0; i < this.sort.length; i++) {
					if (i > 0) sortParam += ",";

					var fieldAndDir = this.sort[i];
					sortParam += `${fieldAndDir.field}|${fieldAndDir.dir}`;
				}

				data["sort"] = sortParam;
			}

			if (this.query.page) {
				data["page"] = this.query.page;
			}

			if (this.query.pageSize) {
				data["pageSize"] = this.query.pageSize;
			}

			if (this.filters && this.filters.length > 0) {
				this.filters.forEach(element => {
					switch (element.id) {
						case "timerange":
							data["dateRange.From"] = moment(element.value.startRange)
								.utc()
								.format();
							data["dateRange.To"] = moment(element.value.endRange)
								.utc()
								.format();
							break;
						case "divisions":
							if (element.value) {
								data["division"] = element.value;
							}
							break;
						case "groups":
							if (element.value && element.value != -1) {
								data["group"] = element.value;
							}
							break;
						case "vehicles":
							if (element.value && element.value.length > 0) {
								for (var j = 0; j < element.value.length; j++) {
									var field = `${self.vehicleIdFilterFieldFormatted}[${j}]`;
									var value = element.value[j];

									data[field] = value;
								}
							}
							break;
						case "drivers":
							if (element.value) {
								data["driver"] = element.value;
							}
							break;
						case "diagnosis-type":
							var types = [];
							if (element.value.anomaly) types.push("anomaly_event");
							if (element.value.information) types.push("info_event");

							if (types.length > 0) {
								data["types"] = types;
							}
							break;
						default:
							break;
					}
				});
			}

			return data;
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		}
	},
	computed: {
		...mapGetters(["settings"])
	}
};
